import { getCtx, ensureAudioContext } from './context.js';
import { beep, noise } from './synth.js';
import { createMusicPlayer } from './music.js';
import type { AudioEngine, AudioEngineConfig, SoundStep } from './types.js';

function playSoundSteps(steps: SoundStep[]): void {
  for (const step of steps) {
    if (step.kind === 'tone') {
      beep(step.freq, step.dur, step.vol, step.wave, step.delay);
    } else {
      noise(step.dur, step.vol, step.delay);
    }
  }
}

/** Create a configured audio engine instance. */
export function createAudioEngine<S extends string>(
  config: AudioEngineConfig<S>,
): AudioEngine<S> {
  const musicVolume = config.musicVolume ?? 0.18;
  const music = createMusicPlayer(config.tracks, config.isMusicEnabled, musicVolume);

  return {
    playSound(name: S): void {
      if (!config.isSfxEnabled()) return;
      const def = config.sounds[name];
      if (typeof def === 'function') {
        def(getCtx());
      } else {
        playSoundSteps(def);
      }
    },

    ensureAudioContext,

    async startMusic(): Promise<void> {
      await music.start();
    },

    onMusicToggle(enabled: boolean): void {
      music.toggle(enabled);
    },

    getCtx,
    beep,
    noise,
  };
}
